import React, { useMemo } from 'react';
import Button from '@web-common/components/UI/Button';
import message from '@web-common/components/UI/Message/SiriusMessage';
import style from './index.module.scss';
import { useAppSelector, MailTemplateActions, useActions } from '@web-common/state/createStore';
import { replaceCurrentMailContent, isDynamicMail, showDynamicMailTemplateWarning } from './utils';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
const SaveAsTemplateComp = (props) => {
    const { isContentChanged } = props;
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const subAccountExpired = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.subAccountExpired, [currentMail]);
    const { doWriteTemplate, changeShowAddTemplatePop } = useActions(MailTemplateActions);
    const replaceCurrentMailContentImg = (content) => {
        const document = new DOMParser().parseFromString(content, 'text/html');
        const imgEls = document.querySelectorAll('img');
        if (imgEls.length > 0) {
            imgEls.forEach(imgEl => {
                const src = imgEl.getAttribute('src');
                if (src && src.indexOf('js6/s') > -1) {
                    imgEl.parentNode.removeChild(imgEl);
                }
            });
            message.warn({
                content: getIn18Text('XIEXINYETUPIAN'),
                duration: 5,
            });
        }
        return document.documentElement.innerHTML;
    };
    const saveAsTemplate = () => {
        if (subAccountExpired)
            return;
        if (isDynamicMail(currentMail)) {
            showDynamicMailTemplateWarning();
            return;
        }
        remWaittingId(currentMailId, true);
        if (currentMail.receiver.length === 0 && !currentMail.entry.title && !isContentChanged) {
            message.warn({
                content: getIn18Text('QINGZHISHAOSHURU11'),
            });
            return;
        }
        const replaceTargets = ['.mail-signature', '.mail-signature-ent', '#divNeteaseBigAttach', '#divNeteaseSiriusCloudAttach', '.pre-mail-content'];
        let content = replaceCurrentMailContent(currentMail.entry.content.content, replaceTargets);
        content = replaceCurrentMailContentImg(content);
        const replacedCurrentMail = Object.assign(Object.assign({}, currentMail), { conference: undefined, entry: Object.assign(Object.assign({}, currentMail.entry), { content: Object.assign(Object.assign({}, currentMail.entry.content), { content }) }) });
        replacedCurrentMail.id = '';
        doWriteTemplate(replacedCurrentMail);
        setTimeout(() => {
            changeShowAddTemplatePop({ isShow: true, source: 'write', isModified: !!isContentChanged });
        }, 200);
    };
    return (React.createElement(React.Fragment, null, currentMail && currentMail.entry && ['common', 'reply', 'forward'].includes(currentMail.entry.writeLetterProp) && (React.createElement("div", { className: `${style.marginRight8}` },
        React.createElement(Button, { id: "saveAsTemplateComp", btnType: "minorGray", size: "small", inline: true, disabled: subAccountExpired, onClick: () => saveAsTemplate() }, getIn18Text('BAOCUNWEIMOBAN'))))));
};
export default SaveAsTemplateComp;
export const SaveAsTemplateCompClone = (props) => {
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const subAccountExpired = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.subAccountExpired, [currentMail]);
    const ckAction = (e) => {
        var _a;
        if (subAccountExpired)
            return;
        e.stopPropagation();
        (_a = document.getElementById('saveAsTemplateComp')) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (React.createElement(React.Fragment, null, currentMail && currentMail.entry && ['common', 'reply', 'forward'].includes(currentMail.entry.writeLetterProp) && (React.createElement("div", { className: `${style.marginRight8}` },
        React.createElement(Button, { btnType: "minorGray", size: "small", inline: true, disabled: subAccountExpired, onClick: e => ckAction(e) }, getIn18Text('BAOCUNWEIMOBAN'))))));
};
